import * as React from 'react'


interface SuggestItemProps {
  item: any
  onClick: (id: number) => void
}

interface SuggestItemState {

}


class SuggestItem extends React.Component<SuggestItemProps, SuggestItemState> {

  handleSuggestMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    // to make sure we don't blur the input element too fast so that the
    // click event wont trigger
    e.preventDefault()
  }

  handleSuggestItemClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.onClick(this.props.item.articleId)
  }

  handleSuggestItemKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.onClick(this.props.item.articleId)
    }
  }

  render () {
    return (
      <div
        className='answers-search-suggest-item'
        onMouseDown={this.handleSuggestMouseDown}
        onClick={this.handleSuggestItemClick}
        role='button'
        tabIndex={0}
        onKeyDown={this.handleSuggestItemKeyDown}
      >
        <div>{this.props.item.text}</div>
    </div>
    )
  }
}

export {
  SuggestItem
}
